<div class="bg">
  <div class="main-wrapper">
   <div class="color-grid">
      <div class="square square-white"  style="--sq-bg:#ffffff; --sq-img:url('assets/images/frame_texto.svg')"></div>
      <div class="square square-green"  style="--sq-bg:#dff2f0; --sq-img:url('assets/images/frame_medica.svg')"></div>
      <div class="square square-yellow" style="--sq-bg:#f7f1d6; --sq-img:url('assets/images/frame_homem_camisa_amarela.svg')"></div>
      <div class="square square-blue"   style="--sq-bg:#e6f1fb; --sq-img:url('assets/images/frame_idoso_correndo.svg')"></div>
    </div>


    <!-- Seção do formulário -->
    <div class="login-card">
      <div class="login-form-container" style="width: 100% ;">
        <img src="assets/svg/logos/saude_conectada_logo.svg" alt="" style="display: block; margin: 0 auto;"/>
        <div class="" style="height: 2em"></div>

        <p class="instructions">
          Olá, insira os dados da sua conta para realizar o acesso à plataforma.
        </p>
        <form [formGroup]="loginForm" class="login-form">
          <div class="" style="height: 2em"></div>
          <!-- Email -->
          <mat-form-field appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-error
              *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
            >
              {{ getPasswordErrorMessage() }}
            </mat-error>
          </mat-form-field>
          <div
            *ngIf="loginErrorMessage() && !loginForm.get('email')?.invalid"
            class="backend-error"
          >
            {{ loginErrorMessage() }}
          </div>

          @if(!!loginErrorMessage()) {
          <div class="" style="height: 1em"></div>
          }

          <!-- Senha -->
          <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input
              matInput
              [type]="hide() ? 'password' : 'text'"
              formControlName="senha"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="showOrHidePassword($event)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide()"
            >
              <mat-icon
                >{{ hide() ? 'visibility_off' : 'visibility' }}</mat-icon
              >
            </button>
            <mat-error
              *ngIf="loginForm.get('senha')?.touched && loginForm.get('senha')?.invalid"
            >
              {{ getPasswordErrorMessage() }}
            </mat-error>
          </mat-form-field>
          <div
            *ngIf="loginErrorMessage() && !loginForm.get('senha')?.invalid"
            class="backend-error"
          >
            {{ loginErrorMessage() }}
          </div>

          <a href="/auth/recuperar-senha" class="forgot-password">
            Esqueci minha senha
          </a>

          <button
              matButton="filled"
              class="login-button full-width"
              type="button"
              [disabled]="loginForm.invalid"
              (click)="defaultAuthentication()"
            >
              Entrar
            </button>

          <div class="privacy">
            <mat-checkbox
              class="custom-checkbox"
              (change)="togglePrivacyPolicy()"
            ></mat-checkbox>
            <p>
              Eu li concordo com o termo de
              <span class="privacy-link" (click)="abrirPoliticaDePrivacidade()"
                >Política de Privacidade</span
              >
              do Saúde Conectada.
            </p>
          </div>

          <img src="assets/svg/logos/sesi_logo.svg" alt="" class="sesi-logo" />
        </form>
      </div>
    </div>
  </div>
</div>
